import { render } from "./ArchiveBox.vue?vue&type=template&id=97f73692"
import script from "./ArchiveBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArchiveBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97f73692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97f73692', __exports__)) {
    api.reload('97f73692', __exports__)
  }
  
  module.hot.accept("./ArchiveBox.vue?vue&type=template&id=97f73692", () => {
    api.rerender('97f73692', render)
  })

}


export default __exports__